import { render, staticRenderFns } from "./lab_area_page.vue?vue&type=template&id=3fd2263a&scoped=true"
import script from "./lab_area_page.vue?vue&type=script&lang=js"
export * from "./lab_area_page.vue?vue&type=script&lang=js"
import style0 from "./lab_area_page.vue?vue&type=style&index=0&id=3fd2263a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2263a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd2263a')) {
      api.createRecord('3fd2263a', component.options)
    } else {
      api.reload('3fd2263a', component.options)
    }
    module.hot.accept("./lab_area_page.vue?vue&type=template&id=3fd2263a&scoped=true", function () {
      api.rerender('3fd2263a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/lab_area_page.vue"
export default component.exports